import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Center, Loader } from '@mantine/core';

/**
 * Public routes that redirect to dashboard if already authenticated
 * (e.g., login, register)
 */
export function PublicRoute() {
  const { isAuthenticated, isLoading, isInitialized } = useAuth();

  // Show loader while checking auth status
  if (!isInitialized || isLoading) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
